var $6d042cae6243464b$exports = {};
$6d042cae6243464b$exports = {
    "alpha": `Alfa`,
    "blue": `Blauw`,
    "brightness": `Helderheid`,
    "green": `Groen`,
    "hue": `Kleurtoon`,
    "lightness": `Lichtsterkte`,
    "red": `Rood`,
    "saturation": `Verzadiging`
};


export {$6d042cae6243464b$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
